import React from 'react';
import './RecordsLoader.css';

const RecordsLoader = ({ title, description, compact = false }) => {
  if (compact) {
    return (
      <span className="records-loading-inline" role="status">
        <span className="records-loading-spinner" aria-hidden="true" />
        {title}
      </span>
    );
  }

  return (
    <div className="records-loading-panel" role="status" aria-live="polite">
      <div className="records-loading-spinner" aria-hidden="true" />
      <div className="records-loading-title">{title}</div>
      <p className="records-loading-description">{description}</p>
      <div className="records-loading-preview" aria-hidden="true">
        {[0, 1, 2].map(row => (
          <div className="records-loading-row" key={row}>
            <span /><span /><span />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecordsLoader;
